import { render, staticRenderFns } from "./menu2.vue?vue&type=template&id=d9c25e26"
import script from "./menu2.vue?vue&type=script&lang=js"
export * from "./menu2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports